var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backlinksWrap"},[_c('GoBack',{attrs:{"title":_vm.title}}),_c('iframe',{attrs:{"src":_vm.link,"width":"100%","height":"80%","frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }